@if (product) {

<div class="w-12 inline-block pe-auto pos-relative _inner flex"
     [style.margin-top.px]="client.sizeId < 2 ? 2 : 4">
    <div class="w-12 h-100">
        <div class="_section pos-relative">
            <href [link]="!canAdd ? product.data?.url : undefined">
                <product-listing-add-to-basket-button-exp class="fill ng-hide ng-hide-animate"
                                                          [product]="product"
                                                          [canAdd]="canAdd"
                                                          [buyRequest]="buyRequest"
                                                          [listPosition]="listPosition"
                                                          (mouseenter)="handleMouseEnter()"
                                                          (click)="handleMouseEnter()" />
            </href>
        </div>
    </div>

    @if (showOptions) {
    <product-listing-configurable-options-exp class="fill z-1 _section ng-hide ng-hide-animate"
                                              [product]="product"
                                              [color]="color"
                                              [listPosition]="listPosition" />
    }

    <ng-container *ifBrowser>
        @if (!wishlistCarouselItem) {
        <div class="_section"
             [ngClass]="[3,1].includes(listingSize) ? '_wishlist-wide' : 'ratio-1-1 _wishlist-narrow'"
             [style.margin-left.px]="client.sizeId < 2 ? 2 : 4">
            <div class="pos-absolute fill flex flex-middle flex-justify-center">
                @if (!!wishlistItem) {
                <wishlist-remove [item]="wishlistItem"
                                 [wrapButton]="true" />
                } @else {
                <product-listing-wishlist-toggle class="_on-product _exp flex flex-middle"
                                                 [product]="product"
                                                 [listPosition]="listPosition"
                                                 [selection]="configurableSelection" />
                }
            </div>
        </div>
        }
    </ng-container>
</div>
}
